<template>
    <div class="animated fadeIn bgV2">
        <b-row>
            <b-col md="12">
                <gofix-tab
                        class="mt-3 checklistTempTab"
                        :data="detailTabs"
                        activeKey="basic_info">
                    <template slot="gofixTab:right">
                        <gofix-button v-if="this.user.id != 0"
                            :loading="disabled"
                            :disabled="$disabledCreateOrUpdate(this.user, $accessModule.safety_app_users)"
                            label="Save"
                            @click="save"></gofix-button>
                        <gofix-button v-if="this.user.id == 0"
                            :loading="disabled"
                            :disabled="$disabledCreateOrUpdate(this.user, $accessModule.safety_app_users)"
                            label="Save"
                            @click="check_save"></gofix-button>
                    </template>
                    <template slot="gofixTab:basic_info">
                        <b-form autocomplete="off">
                            <gofix-card classContent="mb-0">
                                <b-row class="mt-4">
                                    <b-col md="4">
                                        <gofix-form-dropdown
                                            label="Company"
                                            vLabel="name"
                                            :disabled="!isAllowUpdate"
                                            @search="searchOrganization"
                                            :filterable="false"
                                            v-model="$v.user.organization.$model"
                                            :options="organizations"
                                            :clearable="false"
                                            required
                                            showIconRequired>
                                            <template  #gofixInput:dropdown:no-options>
                                                Please enter to search organization!
                                            </template>
                                            <template #gofixInput:dropdown:option="{name}">
                                                <span class="color-000">{{ name }}</span>
                                            </template>
                                            <template #gofixInput:dropdown:selected-option="{name}">
                                                <span class="color-000">{{ name }}</span>
                                            </template>
                                        </gofix-form-dropdown>
                                    </b-col>
                                    <b-col md="4">
                                        <b-form-checkbox :disabled="!isAllowUpdate" v-model="user.active" class="ml-16 mt-30"><span class="ml-2">Disabled</span></b-form-checkbox>
                                    </b-col>
                                    <b-col md="4">
                                        <gofix-text-field class="ml-16 mt-30" label="MS OTP Authentication" oneline>
                                            <b-form-checkbox :disabled="!isAllowUpdate || $disabledCreateOrUpdate(this.user, $accessModule.safety_app_users)" :value="true" v-model="user.microsoft2fa_enable" :unchecked-value="false" switch>
                                            </b-form-checkbox>
                                        </gofix-text-field>
                                    </b-col>
                                </b-row>
                            </gofix-card>
                            <gofix-card>
                                <b-row class="mt-4">
                                    <b-col md="4">
                                        <gofix-form-input :disabled="!isAllowUpdate" label="User Name" v-model="$v.user.name.$model" autocomplete="off" required showIconRequired></gofix-form-input>
                                    </b-col>
                                    <b-col md="4">
                                        <gofix-form-input :disabled="!isAllowUpdate" required label="Department" v-model="user.department" autocomplete="off" showIconRequired></gofix-form-input>
                                    </b-col>
                                    <b-col md="4">
                                        <gofix-form-input :disabled="!isAllowUpdate" label="Designation" v-model="user.designation" autocomplete="off"></gofix-form-input>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col md="4">
                                        <gofix-form-dropdown
                                            label="Role"
                                            vLabel="name"
                                            :filterable="true"
                                            :multiple="true"
                                            :required="true"
                                            showIconRequired
                                            v-model="user.role"
                                            :options="allowRoles">
                                        </gofix-form-dropdown>
                                    </b-col>
                                    <b-col md="4">
                                        <gofix-form-dropdown
                                            label="GOfix Project"
                                            vLabel="reference_value_text"
                                            :disabled="!isAllowUpdate"
                                            :filterable="true"
                                            :multiple="true"
                                            required
                                            showIconRequired
                                            show-icon-required
                                            v-model="$v.user.gofix_projects.$model"
                                            :options="gofixProjects">
                                        </gofix-form-dropdown>
                                    </b-col>
                                    <b-col md="4">
                                        <gofix-form-input label="Email" type="email" v-model="$v.user.email.$model" autocomplete="off" required :disabled="!$route.path.includes('add')" showIconRequired></gofix-form-input>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col md="4">
                                        <gofix-form-input :disabled="!isAllowUpdate" label="Password" type="password" v-model="$v.user.password.$model" autocomplete="new-password" :required="$route.path.includes('add')" :showIconRequired="$route.path.includes('add')">
                                            <template slot="gofixInput:text:after-desc">
                                                <p class="desc">
                                                    <small v-if="$v.user.repassword.$error" class="clear-small label-error">Password doesn’t match</small>
                                                </p>
                                            </template>
                                        </gofix-form-input>
                                    </b-col>
                                    <b-col md="4">
                                        <gofix-form-input :disabled="!isAllowUpdate" label="Confirm Password" type="password" v-model="$v.user.repassword.$model" autocomplete="new-password" :required="$route.path.includes('add')" :showIconRequired="$route.path.includes('add')">
                                            <template slot="gofixInput:text:after-desc">
                                                <p class="desc">
                                                    <small v-if="$v.user.repassword.$error" class="clear-small label-error">Password doesn’t match</small>
                                                </p>
                                            </template>
                                        </gofix-form-input>
                                    </b-col>
                                     <b-col md="2">
                                        <gofix-form-input
                                            :value="user.email_verified_at | formatDatebyMoment('YYYY-MM-DD HH:mm:ss','DD.MM.YYYY HH:mm')"
                                            desc="dd.mm.yyyy hh:mm"
                                            label="Email verified at"
                                            disabled>
                                        </gofix-form-input>
                                    </b-col>
                                    <b-col md="2">
                                        <gofix-form-dropdown
                                            label="Preferred Mode of Contact"
                                            :clearable="false"
                                            vLabel="reference_value_text"
                                            :disabled="!isAllowUpdate"
                                            :reduce="option => option.reference_value_text"
                                            :filterable="false"
                                            v-model="user.preferred_contact_mode"
                                            :disable-capitalize-label="true"
                                            :options="preferred_mode">
                                        </gofix-form-dropdown>
                                    </b-col>
                                </b-row>
                                <b-row class="mb-16">
                                    <b-col md="8" v-if="userType === 'fm-officer'">
                                        <gofix-form-dropdown
                                            label="Client Contract Name"
                                            vLabel="contract_name"
                                            :multiple="true"
                                            :append-to-body="true"
                                            :required="true"
                                            showIconRequired
                                            :options="client_contracts"
                                            v-model="user.contract_ids">
                                        </gofix-form-dropdown>
                                    </b-col>
                                    <b-col md="8" v-if="!$route.path.includes('add')">
                                        <gofix-form-dropdown
                                            label="Roles(not in Safety App)"
                                            vLabel="name"
                                            multiple
                                            disabled
                                            :options="[]"
                                            v-model="rolesNotInSafety">
                                        </gofix-form-dropdown>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <!-- <b-col md="4" class="custom-cases gofixLogoContract gofixSignature">
                                        <gofix-text-field label="Signature" class="editPhotoValue" classLabel="font-14" classValue="pl-0" classInner="d-block" oneline>
                                            <div class="d-flex align-items-center viewer mt-11">
                                                <template v-if="user.signature_image">
                                                    <viewer-image :images="user.signature_image" classViewer='d-flex align-items-center'>
                                                        <template slot="gofixViewer:list_image" ref="viewerFinding" slot-scope="{images}">
                                                            <ul class="list-thumb list-unstyled max-width-per-100 mb-0">
                                                                <li class="mb-0 mr-10" v-for="(item, key) in images" v-bind:key="key">
                                                                    <img v-auth-image="item.url.original" :alt="item.image_file_name || 'image'"  src="img/loading.gif">
                                                                </li>
                                                            </ul>
                                                        </template>    
                                                    </viewer-image>
                                                </template>
                                                <div class="upload-btn-wrapper m-0">
                                                    <b-form-file v-model="attachmentFile" accept=".jpg, .png, .gif" plain></b-form-file>
                                                    <gofix-button :label="!user.signature_image || !user.signature_image.length ? 'ADD PHOTO' : 'CHANGE PHOTO'" outline v-if="isAllowUpdate"></gofix-button>
                                                </div>
                                            </div>
                                        </gofix-text-field>
                                    </b-col> -->
                                </b-row>
                            </gofix-card>
                            <gofix-card v-if="!$route.path.includes('add')">
                                <b-row class="mt-4">
                                    <b-col md="4">
                                        <gofix-text-field classLabel="width-120" label="Login Count" oneline>{{ userDataRead.login_count ? userDataRead.login_count: 0 }}</gofix-text-field>
                                    </b-col>
                                    <b-col md="8">
                                        <gofix-text-field classLabel="width-120" label="Last Login At" oneline>{{ userDataRead.last_login ? userDataRead.last_login: null | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY HH:mm") }}</gofix-text-field>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-4">
                                    <b-col md="4">
                                        <gofix-text-field classLabel="width-120" label="Created At" oneline>{{ userDataRead.created_at ? userDataRead.created_at: null | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY HH:mm") }}</gofix-text-field>
                                    </b-col>
                                    <b-col md="8">
                                        <gofix-text-field classLabel="width-120" label="Created By" oneline>{{ userDataRead.created_by_name }}</gofix-text-field>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-4">
                                    <b-col md="4">
                                        <gofix-text-field classLabel="width-120" label="Last Updated At" oneline>{{ userDataRead.updated_at ? userDataRead.updated_at: null | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY HH:mm") }}</gofix-text-field>
                                    </b-col>
                                    <b-col md="8">
                                        <gofix-text-field classLabel="width-120" label="Updated By" oneline>{{ userDataRead.updated_by_name }}</gofix-text-field>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-4" v-if="$route.params.user_id">
                                    <b-col md="12">
                                      <gofix-button label="See last 10 logins" @click="modals.last_login.open = true"></gofix-button>
                                    </b-col>
                                </b-row>
                            </gofix-card>
                            <!-- <div>
                                <h3 class="gofixContentTitle">Address</h3>
                            </div>
                            <template v-for="(address,index) in user.address">
                                <gofix-card classContent="mb-0 position-relative" :key="index">
                                    <template slot="gofixCard:before_card_content">
                                        <button class="icon-button gofixIconButton gofixPositionTopRight position-absolute" @click="removeUserAddress(index)" v-if="isAllowUpdate">
                                            <svg width="18" height="20" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M1 5H19" stroke="#999999" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M6 5V3C6 2.46957 6.21071 1.96086 6.58579 1.58579C6.96086 1.21071 7.46957 1 8 1H12C12.5304 1 13.0391 1.21071 13.4142 1.58579C13.7893 1.96086 14 2.46957 14 3V5M17 5V19C17 19.5304 16.7893 20.0391 16.4142 20.4142C16.0391 20.7893 15.5304 21 15 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5H17Z" stroke="#999999" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M8 10V16" stroke="#999999" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M12 10V16" stroke="#999999" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>
                                        </button>
                                    </template>
                                    <div class="pr-4">
                                        <b-row class="mt-4">
                                            <b-col md="4">
                                                <gofix-form-dropdown
                                                    label="Salutation"
                                                    vLabel="reference_value_text"
                                                    :filterable="false"
                                                    :required="user.mailing_address_id_tmp === index"
                                                    v-model="address.salutation"
                                                    :reduce="option => option.reference_value_text"
                                                    :options="salutations">
                                                </gofix-form-dropdown>
                                            </b-col>
                                            <b-col md="4">
                                                <gofix-form-input
                                                    :required="user.mailing_address_id_tmp === index"
                                                    label="First Name"
                                                    autocomplete="off"
                                                    v-model="address.first_name"></gofix-form-input>
                                            </b-col>
                                            <b-col md="4">
                                                <gofix-form-input
                                                    :required="user.mailing_address_id_tmp === index"
                                                    label="Last Name"
                                                    autocomplete="off"
                                                    v-model="address.last_name"></gofix-form-input>
                                            </b-col>
                                            <b-col md="4">
                                                <gofix-text-field label="Address">
                                                    <template slot="gofixTextField:after_label">
                                                        <gofix-button class="editRight float-right" label="Edit" noBorder fontNormal small @click="openAddressModal(address,index)" v-if="isAllowUpdate"></gofix-button>
                                                    </template>
                                                    {{address.display_address}}
                                                </gofix-text-field>
                                            </b-col>
                                            <b-col md="4">
                                                <gofix-form-input-number
                                                    label="Mobile Phone"
                                                    v-model="address.primary_phone"
                                                    :integer-limit="15"
                                                    :include-thousands-separator="false"
                                                    :allowDecimal="false">
                                                </gofix-form-input-number>
                                            </b-col>
                                            <b-col md="4">
                                                <b-form-checkbox class="ml-16 mt-30" v-model="address.phone_verified"><span class="ml-2">Mobile Phone Verified</span></b-form-checkbox>
                                            </b-col>
                                            <b-col md="4">
                                                <gofix-form-input-number
                                                    label="Second Phone"
                                                    v-model="address.secondary_phone"
                                                    :integer-limit="15"
                                                    :include-thousands-separator="false"
                                                    :allowDecimal="false">
                                                </gofix-form-input-number>
                                            </b-col>
                                            <b-col md="4">
                                                <gofix-form-input
                                                    :required="user.mailing_address_id_tmp === index"
                                                    label="Email Address"
                                                    v-model="address.email"
                                                    type="email" autocomplete="off"></gofix-form-input>
                                            </b-col>
                                            <b-col md="4">
                                                <div class="d-flex justify-content-between">
                                                    <b-form-checkbox class="ml-16 mt-30" v-model="address.email_verified"><span class="ml-2">Email Verified</span></b-form-checkbox>
                                                    <b-form-checkbox class="ml-16 mt-30" v-model="user.mailing_address_id_tmp" :value="index"><span class="ml-2">Default Mailing</span></b-form-checkbox>
                                                    <b-form-checkbox class="ml-16 mt-30" v-model="user.billing_address_id_tmp" :value="index"><span class="ml-2">Default Billing</span></b-form-checkbox>
                                                </div>
                                            </b-col>
                                        </b-row>
                                    </div>
                                </gofix-card>
                            </template>
                            <div class="action">
                                <gofix-button label="Add Address" @click="addUserAddress" outline v-if="isAllowUpdate"></gofix-button>
                            </div> -->
                        </b-form>
                    </template>
                </gofix-tab>
            </b-col>
        </b-row>
        <b-modal :no-close-on-backdrop="true" id="modal-Address" title="Address" hide-footer :centered="true" ref="modal-address">
            <b-form class="pb-10">
                <gofix-form-input label="Street Number" v-model="activeAddress.street_no"></gofix-form-input>
                <gofix-form-input label="Street Name" v-model="activeAddress.street_name"></gofix-form-input>
                <gofix-form-input label="Unit no" v-model="activeAddress.unit_no"></gofix-form-input>
                <gofix-form-input label="Building Name" v-model="activeAddress.building_name"></gofix-form-input>
                <gofix-form-input label="Country" v-model="activeAddress.country" disabled></gofix-form-input>
                <gofix-form-input label="Postal code" v-model="activeAddress.postal_code"></gofix-form-input>
            </b-form>
            <b-button-group class="d-block text-right">
                <gofix-button label="SUBMIT" @click="hanldeAddress" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
        <b-modal :no-close-on-backdrop="true" id="modal-Create-Check-User" :title="modals.title" hide-footer :centered="true" v-model="modals.open" ref="modal-check">
            <b-form>
                <b-row>
                    <b-col md="12">
                        <p style="font-size: 14px; color: rgba(0, 0, 0, 0.6);">
                            Your email has already existed and being marked as disabled. Do you want:
                        </p>
                    </b-col>
                    <b-col md="12">
                        <gofix-button
                            label="Recover the existing account"
                            class="mr-3"
                            @click="save(2)"
                        ></gofix-button>
                        <gofix-button
                            label="Create a new account"
                            class="mr-3"
                            @click="save(3)"
                        ></gofix-button>
                        <gofix-button
                            label="Cancel"
                            @click="save(0)"
                        ></gofix-button>
                    </b-col>
                </b-row>
            </b-form>
        </b-modal>
        <b-modal :no-close-on-backdrop="true" id="modal-Create-Check-User" :title="modals.last_login.title" hide-footer :centered="true" v-model="modals.last_login.open" ref="modal-check">
            <div class="pl-10 pr-10">
            <ul class="list-unstyled list-client" v-if="login_histories" v-bind:class="{'run-loading':modals.last_login.loading}">
                <template v-for="(item, index) in login_histories">
                <li v-bind:key="item.id">
                    <p>
                    IP: {{ item.ip }}
                    <small>Login at: {{ item.login_date | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY HH:mm:ss")}}</small>
                    <small>Logout at: {{ item.logout_date | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY HH:mm:ss")}}</small>
                    <small>Bowse engine: {{ item.browse_engine}}</small>
                    </p>
                </li>
                </template>
            </ul>
            </div>
        </b-modal>
        <b-toast id="toast-custom1" variant="danger" solid>
        <template #toast-title>
            <div class="d-flex flex-grow-1 align-items-baseline">
            <strong class="mr-auto">Notification</strong>
            </div>
        </template>
        <div class="err-pwd-toast" v-if="errorMessage">
            <div v-html="errorMessage"></div>
        </div>
        </b-toast>
        <b-modal :no-close-on-backdrop="true" id="modal-Remove" hide-footer hide-header :centered="true" v-model="modals.warning.open">
            <div class="py-3 px-1 text-center">
                <h4>User already exists</h4>
               A user with this information already exists.
                <br>You cannot create a duplicate user.
                <br>Would you like to go to the <b>Edit User</b> page to add an additional role?
            </div>
            <b-button-group class="btn-group">
                <b-button class="custom-btn" @click="modals.warning.open = false">No</b-button>
                <b-button class="custom-btn" @click="redirectUserExisting">Yes</b-button>
            </b-button-group>
    </b-modal>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex';
    import { validationMixin } from 'vuelidate'
    import { required, email, sameAs, minLength ,requiredIf} from 'vuelidate/lib/validators'
    import { generalAddressFormat } from "@/_commonVar.js";
    const ViewerImage = () => import('@/views/plugins/ViewerImage.vue')
    
    export default {
        name: 'user-info',
        components: {
            ViewerImage
        },
        data () {
            return {
                userType: "fm-officer",
                detailTabs:[
                    {
                        key: "basic_info",
                        title: "basic info",
                        active: true,
                    },
                ],
                errorMessage:null,
                disabled: false,
                user: {
                    id: '',
                    name: '',
                    department: '',
                    designation:null,
                    organization: null,
                    email: '',
                    password: '',
                    repassword : '',
                    address: [],
                    primary_phone: '',
                    active: false,
                    role:[],
                    email_verified_at: null,
                    preferred_contact_mode: "Email",
                    mailing_address_id: null,
                    mailing_address_id_tmp: null,
                    billing_address_id: null,
                    billing_address_id_tmp: null,
                    contract_id: null,
                    property_id: null,
                    property: null,
                    microsoft2fa_enable:false,
                    gofix_projects: null,
                    contract_ids: []
                },
                userDataRead: {
                    login_count: null,
                    last_login: null,
                    created_at: null,
                    created_by_name: null,
                    updated_at: null,
                    updated_by_name: null,
                },
                organizations : [],
                client_contracts : [],
                group_tags : "FM",
                modals:{
                    open:false,
                    loading:false,
                    title:"Create User",
                    restore_user_id:null,
                    last_login:{
                      open:false,
                      loading:false,
                      title:"Latest login",
                    },
                    fm_allow_roles: [],
                    warning: {
                        open: false,
                        user_id: null
                    }
                },
                activeAddress: {},
                salutations:[],
                preferred_mode:[],
                login_histories: [],
                attachmentFile: null,
                gofixProjects: []
            }
        },
        mixins: [validationMixin],
        validations: {
            user: {
                name: {
                    required
                },
                email: {
                    email,
                    required: requiredIf(function() {
                        return this.$route.path.includes('add');
                    })
                },
                password: {
                    required: requiredIf(function(){
                        return this.$route.path.includes('add')
                    })
                },
                repassword: {
                    sameAsPassword: sameAs("password"),
                    required: requiredIf(function() {
                        return this.$route.path.includes('add');
                    })
                },
                organization: {
                    required
                },
                gofix_projects: {
                    required
                }
            }
        },
        async created () {
            if(!this.$route.path.includes('add') && (!this.$route.params.hasOwnProperty('user_id') || isNaN(this.$route.params.user_id))) {
                return this.$router.push(this.$route.matched[this.$route.matched.length - 1].parent.path);
            }

            await this.setUserType();
            if(!this.$route.path.includes('add')) {
                await this.getUser();
            } else {
                this.$store.commit('v2UserController/setItemUser', null);
                if(this.ClientContractID && this.ClientContractID.id) {
                    this.user.contract_ids = [this.ClientContractID]
                }
            }

            if(this.user.organization){
                if(this.user.organization.is_fm_company){
                    this.group_tags = "FM";
                }
                if(this.user.organization.is_supplier){
                    this.group_tags = "Supplier";
                }
            }else{
                if(this.$route.path.includes('supplier')) {
                    this.group_tags = "Supplier";
                }
                if(this.$route.path.includes('fm-officer')) {
                    this.group_tags = "FM";
                }
                
            }

            let params = {
                filter: {
                    group_tags : this.group_tags
                }
            }
            if(this.group_tags == 'FM') {
                params.allow_roles = ['Project Manager']
            }

            this.getFMAllowRoles();
            this.$store.dispatch("RoleController/getRoleItems",params);
            this.getSalutations();
            this.getPreferredMode();
            this.loadLoginHistories();
            this.getPreferredGofixProjects();
            this.getOrganizations();
        },
        watch:{
            "user.organization" : function(val,old){
                if(val){
                    if(val.is_fm_company){
                        this.group_tags = "FM";
                    }
                    if(val.is_supplier){
                        this.group_tags = "Supplier";
                    }

                    let params = {
                        filter: {
                            group_tags : this.group_tags
                        }
                    }
                    if(this.group_tags == 'FM') {
                        params.allow_roles = ['Project Manager']
                    }

                    this.$store.dispatch("RoleController/getRoleItems",params);
                }
            },
            "attachmentFile": function (val) {
                if (val) {
                    if (val.type !== 'image/jpeg' && val.type !== 'image/png' && val.type !== 'image/gif') {
                        this.$alertNotification("File format is incorrect. Please select a .jpeg, .jpg, .png, .gif file!", "warning");
                        return;
                    }

                    var _this = this;
                    const img = new Image();
                    img.src = URL.createObjectURL(val);

                    let data = {
                        url: {
                            original: URL.createObjectURL(val),
                            medium: URL.createObjectURL(val),
                            thumb: URL.createObjectURL(val)
                        }
                    };
                    
                    if(!this.user.signature_image || !this.user.signature_image.length)
                        this.user.signature_image = [data]
                    else
                        this.user.signature_image[0].url = data.url;
                }
            },
            "modals.fm_allow_roles": function(val) {
                if(val && val.length) {
                    this.user.role = this.user.role.filter(item => val.includes(item.name))
                }
            },
            IteamUser: function(val) {
                if(val && val.roles && val.roles.length) {
                    this.user.role = val.roles.filter(item => this.modals.fm_allow_roles.includes(item.name))
                }
            },
            "modals.fm_allow_roles": function(val) {
                if(val && val.length && this.IteamUser && this.IteamUser.roles && this.IteamUser.roles.length) {
                    this.user.role = this.IteamUser.roles.filter(item => val.includes(item.name))
                }
            }
        },
        computed: {
            ...mapGetters({
                Items: 'v2UserController/ListingUser',
                IteamUser: 'v2UserController/IteamUser',
                Organizations: 'OrganizationController/Organizations',
                RoleItems: 'RoleController/RoleItems',
            }),
            isAllowUpdate() {
                if(!this.user.id) return true;
                if(this.user && this.user.is_safety) {
                    if(this.rolesNotInSafety.length) {
                        return false
                    }
                    return true
                }
               return false
            },
            allowRoles() {
                if(this.RoleItems && this.RoleItems.data && this.RoleItems.data.length) {
                    return this.RoleItems.data.filter(item => this.modals.fm_allow_roles.includes(item.name))
                }
                return []
            },
            rolesNotInSafety() {
                if(this.IteamUser && (this.IteamUser.id == this.$route.params.user_id) && this.IteamUser.roles && this.IteamUser.roles.length && this.modals.fm_allow_roles.length) {
                    return this.IteamUser.roles.filter(item => !this.modals.fm_allow_roles.includes(item.name))
                }
                return []
            }
        },
        methods:{
            async getUser() {
                await this.$store.dispatch('v2UserController/getUser', this.$route.params.user_id)
                    .then(response => { this.setData(response.data.data) })
                    .catch(error => {})
            },
            convertNewLine(str){
                return str.replace(/\n/g, '<br />');
            },
            setData(data) {
                if(data != null) {
                    this.user.id = data.id
                    this.user.name = data.name,
                    this.user.department = data.department,
                    this.user.designation = data.designation,
                    this.user.email = data.email,
                    this.user.organisation_id = data.organisation_id,
                    this.user.organization = data.organization;
                    // this.user.role = data.roles;
                    this.user.active = data.active;
                    this.user.email_verified_at = data.email_verified_at;
                    this.user.preferred_contact_mode = data.preferred_contact_mode;
                    this.user.address = data.address;
                    this.user.password = '';
                    this.user.repassword = '';
                    this.user.mailing_address_id = data.mailing_address_id;
                    this.user.billing_address_id = data.billing_address_id;
                    this.user.property = data.property;
                    this.user.microsoft2fa_enable = data.microsoft2fa_enable;
                    this.user.active = !data.active;
                    if(data.id == '' || data.id == null) {
                        this.user.password = data.password
                        this.user.repassword = data.repassword
                    }
                    if(data.mailing_address_id){
                        this.user.mailing_address_id_tmp = data.address.findIndex(item => item.id === data.mailing_address_id)
                    }
                    if(data.billing_address_id){
                        this.user.billing_address_id_tmp = data.address.findIndex(item => item.id === data.billing_address_id)
                    }
                    if(data.tenant){
                        this.user.contract_id = data.tenant.client_contract_id;
                        this.user.property_id = data.tenant.property_id;
                    }

                    this.userDataRead = {
                        ...this.userDataRead,
                        ... {
                            login_count: data.login_count,
                            last_login: data.last_login,
                            created_at: data.created_at,
                            created_by_name: data.created_by && data.created_by.name && data.created_by.name ? data.created_by.name : null,
                            updated_at: data.updated_at,
                            updated_by_name: data.updated_by && data.updated_by.name && data.updated_by.name ? data.updated_by.name : null,
                        }
                    };

                    this.user.signature_image =  data.signature_image
                    this.user.gofix_projects =  data.gofix_projects
                    this.user.is_safety =  data.is_safety
                    this.user.contract_ids = data.contract_ids
                    return;
                }
                this.user.role = []
                this.user.password = ''
                this.user.repassword = ''
            },
            check_save() {
                if(this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                this.timer = setTimeout(() => {
                    this.modals.restore_user_id = null;
                    this.modals.warning.user_id = null;
                    this.$v.user.$touch();
                    if(this.$v.user.$error){
                        if(!this.user.email) return this.$alertNotification("Email is a required field.", "danger");
                        if(!this.user.gofix_projects || !this.user.gofix_projects.length) return this.$alertNotification("GOfix project is a required field.", "danger");
                        return this.$alertNotification("User is a required field.", "danger");
                    }
                    let params = {
                        email : this.user.email
                    }
                    this.$store.dispatch(`v2UserController/checkUser`, params)
                        .then(response => {
                            if(response.data == 0) {
                                this.save(1)
                            }
                            if(response.data == 1) {
                                if(response.user && response.user.id) {
                                    this.modals.warning.user_id = response.user.id
                                    this.modals.warning.open = true
                                    return
                                } else {
                                    return this.$alertNotification(response.message, "danger");
                                }
                            }
                            if(response.data == 2) {
                                this.modals.open = true
                                this.modals.restore_user_id = response.message.id
                            }
                        })
                        .catch(error => {})
                }, 300);
            },
            restore_user() {
                let params = {
                    id : this.modals.restore_user_id
                }
                this.$store.dispatch(`v2UserController/restoreUser`, params)
                    .then( async response => {
                        this.isAction = false;
                        this.$store.dispatch('v2UserController/getListUser', { page: this.Items.pages.page, filter: this.Items.pages.filter, limit: this.Items.pages.limit, isCMS: '1' })
                        this.modals.open = false
                        if(this.$route.path.includes('add')) {
                            this.$store.dispatch('v2UserController/getListUser', { page: this.Items.pages.page, filter: this.Items.pages.filter, limit: this.Items.pages.limit, isCMS: '1' })
                            await this.$router.push(`${this.$route.path.replace("add",this.modals.restore_user_id)}`)
                            //await  this.$router.push(`${this.$route.matched[this.$route.matched.length - 1].parent.path}/${this.modals.restore_user_id}`)
                        }
                        return await this.$alertNotification("Successfully recover user");
                    })
                    .catch(error => {})
            },
            save(check_save = 1) {
                if(check_save === 0) {
                    this.modals.open = false
                    return
                }

                if(!this.user.department){
                    this.$alertNotification("Department is required", "danger");
                    return;
                }
                
                if(check_save === 2) {
                    this.restore_user()
                    return
                }
                if(this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                this.timer = setTimeout(() => {
                    this.$v.user.$touch()
                    if(!this.$v.user.$error){
                        if(this.user.organization != null) {
                            this.user.organisation_id = this.user.organization.id;
                        }
                        if(this.user.property != null) {
                            this.user.property_id = this.user.property.id;
                        }
                        this.disabled = true
                        if(check_save === 3 && (this.user.id == 0 || this.user.id == '')) {
                            this.user.is_delete = true
                        }
                        let method = 'SaveUser'
                        let keyMessage= 'adding'
                        if(this.user.id != 0) {
                            method = 'updateUser'
                            keyMessage = 'editing'
                        }

                        let request = Object.assign({}, this.user);
                        request.is_safety = true;
                        request.active = !request.active;
                        if(request.mailing_address_id_tmp === false) {
                            request.mailing_address_id_tmp = '';
                        }

                        if(request.billing_address_id_tmp === false) {
                            request.billing_address_id_tmp = '';
                        }

                        request.attachment_id = null
                        request.attachment = this.attachmentFile
                        if(request.signature_image && request.signature_image[0] && request.signature_image[0].id) {
                            request.attachment_id = request.signature_image[0].id
                        }

                        if(this.user.id && this.user.id != 0) {
                            request.role = this.rolesNotInSafety;
                            if(this.user.role && this.user.role.length) {
                                request.role = request.role.concat(this.user.role)
                            }
                        }

                        if(request.contract_ids && request.contract_ids.length) {
                            request.contract_ids = request.contract_ids.map(item => item.id)
                        }
                        
                        this.errorMessage = null;
                        this.$store.dispatch(`v2UserController/${method}`, request)
                            .then(async response => {
                                if(response.code == 400){
                                    if(response.data){
                                        this.errorMessage = this.convertNewLine(response.message);
                                        this.$bvToast.show('toast-custom1');
                                    }else{  
                                        this.$alertNotification(response.message, "danger");
                                    }
                                    this.disabled = false;
                                    return;
                                }
                                // this.user.id = response.id;
                                this.disabled = false
                                this.modals.open = false
                                if(this.$route.path.includes('add')) {
                                    this.$router.push(`${this.$route.path.replace("add",response.id)}`)
                                }
                                this.getUser();
                                await this.$alertNotification(this.$notificationV2(keyMessage, 'user'));
                            })
                            .catch(error => {
                                this.disabled = false
                                this.modals.open = false
                                if(error.error.message.password) {
                                    this.$alertNotification(error.error.message.password[0], "danger");
                                }
                                if(error.error.message.email) {
                                    this.$alertNotification(error.error.message.email[0], "danger");
                                }
                            })
                    } else {
                        if(!this.user.gofix_projects || !this.user.gofix_projects.length) return this.$alertNotification("GOfix project is a required field.", "danger");
                    }
                }, 300)
            },
            hanldeAddress() {
                this.activeAddress.display_address = generalAddressFormat(this.activeAddress)
                //this.user.address[this.activeAddress.key] = this.activeAddress.data;
                this.$refs['modal-address'].hide()
            },
            addUserAddress(){
                this.user.address.push({
                    building_name: '',
                    city: null,
                    contact_name: null,
                    country: "Singapore",
                    display_address: "",
                    display_name: "",
                    email: null,
                    email_verified: false,
                    first_name: null,
                    full_address: "",
                    geo_location: null,
                    id: null,
                    last_name: null,
                    phone_verified: false,
                    postal_code: "",
                    primary_phone: "",
                    salutation: null,
                    secondary_phone: null,
                    street_name: "",
                    street_no: "",
                    unit_no: ""
                });
            },
            removeUserAddress(index){
                this.user.address.splice(index, 1);
                if(this.user.mailing_address_id_tmp && index <= this.user.mailing_address_id_tmp){
                    if(index < this.user.mailing_address_id_tmp){
                        this.user.mailing_address_id_tmp = this.user.mailing_address_id_tmp - 1;
                    }else{
                        this.user.mailing_address_id_tmp = null;
                    }

                }
                if(this.user.billing_address_id_tmp && index <= this.user.billing_address_id_tmp){
                    if(index < this.user.billing_address_id_tmp){
                        this.user.billing_address_id_tmp = this.user.billing_address_id_tmp - 1;
                    }else{
                        this.user.billing_address_id_tmp = null;
                    }
                }
            },
            openAddressModal(address,index){
                this.activeAddress = address;
                this.activeAddress.key = index;
                this.$refs['modal-address'].show()
            },
            async setUserType(){
                if(this.$route.path.includes('fm-officer')){
                    this.userType = "fm-officer";
                    //Get contracts
                    await this.getClientContract();
                }

                if(this.$route.path.includes('supplier')){
                    this.userType = "supplier";
                }
            },
            async getClientContract(){
                await this.$store.dispatch('ContractController/getList', {
                    limit  : -1,
                    page   :  1
                })
                    .then(response => {
                        this.client_contracts = response.data.data.contracts
                    }).
                    catch(err => {
                        console.log(err);
                        this.client_contracts = [];
                });
            },
            getSalutations(){
                let filter = {reference_type: "Salutation"};
                let params = {
                    filter: filter,
                    limit: -1,
                    sortColumn: "id",
                    sortDirection: "asc",
                };
                this.$store.dispatch(`ReferenceController/getItems`, params)
                    .then(response => {
                        this.salutations = response.items;
                    })
            },
            getPreferredMode(){
                let filter = {reference_type: "Preferred Mode of Contact"};
                let params = {
                    filter: filter,
                    limit: -1,
                    sortColumn: "id",
                    sortDirection: "asc",
                };
                this.$store.dispatch(`ReferenceController/getItems`, params)
                    .then(response => {
                        this.preferred_mode = response.items;
                    })
            },
            async loadLoginHistories(){
              if(!this.$route.params.user_id) return;
              let tableRequest = {
                limit: 10,
                page: 1,
                isCMS: 1,
                sortColumn: "created_at",
                sortDirection: "DESC",
                filter: {
                  user_id: {
                    type: "number",
                    value: this.$route.params.user_id,
                    function: "=",
                    with: []
                  }
                }
              }
              this.modals.last_login.loading = true;
              await this.$store.dispatch("AuditTrailController/getUserActivityLogs", tableRequest)
                  .then(response => {
                    this.login_histories = response.items;
                    this.tableConfig.total = response.total;
                    this.modals.last_login.loading = false;
                  })
                  .catch(err => {
                    this.modals.last_login.loading = false;
                  })
            },
            getPreferredGofixProjects(){
                let filter = {reference_type: "GOfix Project", reference_value_text: "WSH TC Safety Inspection"};
                let params = {
                    filter: filter,
                    limit: -1,
                    sortColumn: "id",
                    sortDirection: "asc",
                };
                this.$store.dispatch(`ReferenceController/getItems`, params)
                    .then(response => {
                        this.gofixProjects = response.items;
                        if(this.gofixProjects.length && this.$route.path.includes('add')) {
                            this.user.gofix_projects = [this.gofixProjects[0]]
                        }
                    })
            },
            async getOrganizations(search = '') {
                const isSupplier = this.group_tags == 'Supplier' ? true : false;
                await this.$store.dispatch( 'OrganizationController/searchItemsInUser', {
                    page: 1, 
                    isCMS: 1,
                    filter: { 
                        name: { type: "text", value: this.group_tags == 'FM' ? 'EM SERVICES PTE LTD' : search, function: "ilike", with: [] },
                        is_supplier: { type: 'boolean', value: isSupplier },
                        is_safety: isSupplier ? { type: 'boolean', value: true } : undefined,
                        is_fm_company: { type: 'boolean', value: !isSupplier },
                    }, 
                    limit: this.group_tags == 'FM' ? -1 : 100
                }).then(response => { 
                    this.organizations = response.data.data.items;
                    if(this.group_tags == 'FM' && this.$route.path.includes('add') && this.organizations.length) {
                        this.user.organization = this.organizations[0]
                    }
                }).catch(err=> {})
            },
            async searchOrganization(search, loading) {
                this.organizations = []
                if(!this.setValue) {
                    this.setValue = true
                }
                loading(true);
                if(this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                this.timer = setTimeout(async () => {
                      try {
                        await this.getOrganizations(search);
                        await loading(false);
                    } catch(err) {
                        await loading(false);
                    }
                }, 500);
            },
            getFMAllowRoles(){
                let filter = {reference_type: "Safety Roles"};
                let params = {
                    filter: filter,
                    limit: -1,
                    sortColumn: "id",
                    sortDirection: "asc",
                };
                this.$store.dispatch(`ReferenceController/getItems`, params)
                    .then(response => {
                        if(response.items && response.items.length && response.items[0].reference_value_text) {
                            this.modals.fm_allow_roles = response.items[0].reference_value_text.split(", ");
                        }
                        
                    })
            },
            async redirectUserExisting() {
                if(this.modals.warning.user_id) {
                    this.modals.warning.open = false;
                    await this.$router.push(`${this.$route.matched[this.$route.matched.length - 1].parent.path}/${this.userType}/${this.modals.warning.user_id}`);
                    let rolesSafty = this.user.role && this.user.role.length ? this.user.role : []
                    let contract_ids = this.user.contract_ids && this.user.contract_ids.length ? this.user.contract_ids : []
                    await this.getUser();
                    this.user.role = await rolesSafty;
                    this.user.contract_ids = await contract_ids;
                }
            }
        }
    }
</script>
<style>
    .custom-switch .custom-control-input:disabled:checked ~ .custom-control-label::before{
        background-color: #F05600 !important;
    }
</style>